export default __webpack_public_path__ + "static/media/jd.3ff4f6ad.jpeg";